import { FunctionComponent } from "react";
import { JSONSchema7, JSONSchema7Definition } from 'json-schema'
import { TextField } from "@mui/material";
import { PrimaryKeyField } from "./PrimaryKeyField";
import { ForeignKeyField } from "./ForeignKeyField";
import { SelectField } from "./SelectField";
import { minTableColumnWidth } from "./const";
import { ArrayField } from "./ArrayField";
import { FileUploadField } from "./FileUploadField";
interface CartaSchemaProperty{
    "&pk"?: boolean;
    "&fk"?: boolean;
    "cl-format"?: string;

    items?: JSONSchema7['items'] & CartaSchemaProperty
}

export interface TableFormFieldProps {
    property: JSONSchema7Definition & CartaSchemaProperty;
    defaultValue: any;
    onChange: (value: any) => void
}

export const TableFormField: FunctionComponent<TableFormFieldProps> = ({
    property,
    defaultValue,
    onChange
}) => {

    if (typeof property === 'boolean') {
        return (<></>)
    }

    if(property["&pk"]){
        return (
                <PrimaryKeyField defaultValue={defaultValue} required={true} onChange={onChange}/>
        )
    }

    if(property["&fk"]){
        return (
                <ForeignKeyField defaultValue={defaultValue} required={true} onChange={onChange}/>
        )
    }

    if(property["cl-format"] === "image"){
        return <></>;
    }

if(property.type && property.type === 'number'){
        const _onChange = onChange;
        onChange = (e) => _onChange(parseFloat(e));
    }

    if(property.enum){
        return (
            <SelectField 
            label={property.title??""}
            defaultValue={defaultValue} 
            required={false} 
            options={property.enum.map(e=>e?.toString() ?? "")} 
            onChange={onChange}/>
        )
    }

    if(property.type){
        switch(property.type){
            case "array":
                if(typeof property.items === 'object' && !Array.isArray(property.items)){
                    if(property.items.format === 'data-url'){
                        return (<FileUploadField defaultValue={defaultValue} onChange={onChange} multiple={true} required={false}/> )
                    }
                }
                return (
                    <ArrayField schema={property} defaultValue={defaultValue} onChange={onChange} required={false}/>
                )
            case "string":
                if(property.format && property.format === 'data-url'){
                    return (
                        <FileUploadField defaultValue={defaultValue} onChange={onChange} multiple={false} required={false}/>
                    )
                }
        }
    }

    return (
            <TextField
                defaultValue={defaultValue ?? ""}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                style={{minWidth: minTableColumnWidth}}
            />
    )
}